import {ModalForm, ProFormSelect, ProFormText} from '@ant-design/pro-form';
import {Result} from 'antd';
import React, { useEffect, useRef } from "react"
import { useQuery } from "@tanstack/react-query"
import { useNavigate, useParams } from "react-router-dom"
import axiosApiInstance from "../../../../api/axiosClient"
import { ActionType, ProSkeleton } from "@ant-design/pro-components"
import { API } from "../../../../common/constants"
import { useAtomValue, useSetAtom } from "jotai"
import { assetLabelsAtom } from "../ddex_atoms"
import { queryClientAtom } from "jotai-tanstack-query"

const REDIRECT_URL = "/music/labels"

type FormContentProps = {
  initialValues: API.MusicDistribution.Label
}

const EditLabelForm = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const queryClient = useAtomValue(queryClientAtom)
  const isDarkMode = document.documentElement.classList.contains('dark-mode')

  const { data, status } = useQuery({
    queryKey: ["label", id],
    queryFn: () =>
      axiosApiInstance
        .get(`/api/products/labels/${id}`)
        .then(({ data }) => data)
        .catch((reason) => console.error(reason)),
  })

  const FormContent = ({ initialValues }: FormContentProps) => (
    <>
      <ProFormText hidden name="ID" initialValue={initialValues.ID} />
      <ProFormText 
        name="name" 
        label="Name" 
        initialValue={initialValues.name}
        fieldProps={isDarkMode ? {
          style: { backgroundColor: '#262626', color: '#e0e0e0', borderColor: '#434343' }
        } : {}}
      />
      <ProFormText
        name="p_line"
        label="(P) Line"
        initialValue={initialValues.p_line}
        fieldProps={isDarkMode ? {
          style: { backgroundColor: '#262626', color: '#e0e0e0', borderColor: '#434343' }
        } : {}}
      />
      <ProFormText
        name="c_line"
        label="(C) Line"
        initialValue={initialValues.c_line}
        fieldProps={isDarkMode ? {
          style: { backgroundColor: '#262626', color: '#e0e0e0', borderColor: '#434343' }
        } : {}}
      />
      {/* <ProFormSelect
        name={"asset_label_id"}
        label="Asset Label"
        initialValue={initialValues.asset_label.ID || undefined}
        options={assetLabels.map((label) => ({
          label: label.name,
          value: label.ID,
        }))}
      /> */}
    </>
  )

  const renderMap = {
    loading: <ProSkeleton type="list" />,
    error: <Result title="Failed to load label" status="error" />,
    success: <FormContent initialValues={data} />,
  }
  return (
    <ModalForm<API.MusicDistribution.Label>
      title="Edit label"
      labelCol={{ span: 3 }}
      wrapperCol={{ span: 21 }}
      width={1000}
      open
      modalProps={{
        destroyOnClose: true,
        onCancel: () => navigate(REDIRECT_URL),
      }}
      onFinish={async (values) => {
        axiosApiInstance
          .put(`/api/products/labels/`, values)
          .then((response) => {
            console.log(response)
            // actionRef?.current?.reload();
            queryClient.invalidateQueries({ queryKey: ["labels"] })
          })
          .catch((reason) => console.log(reason))
          .finally(() => navigate(REDIRECT_URL))
        return true
      }}
      // style={{ width: 1000 }}
    >
      {renderMap[status]}
    </ModalForm>
  )
}

export default EditLabelForm;
